import React, { useState } from 'react'
import { ProvinceProductModels } from '@getgreenline/products'
import { CreateProduct } from '../ProductStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { ImportProvinceProduct } from '../ProductImport/ImportProvinceProduct'
import { parseProvinceProductAgency } from '../../../../../utilities/helpers'
import { Track } from '../../../../../Track'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import { ImportGlobalProduct } from '../ProductImport/ImportGlobalProduct'
import { IGlobalProduct } from '@getgreenline/global-products'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'

interface Props {
  product: CreateProduct
  currentCompanyStore?: CurrentCompanyStore
  populateProduct: (
    products: ProvinceProductModels.IProvinceProductContract[],
    supplierId?: number,
  ) => void
  populateGlobalProduct: (products: IGlobalProduct[], supplierId?: number) => void
  warning?: string
  activeKeys: string[]
  setActiveKeys: (activeKeys: string[]) => void
  autoScrollToVariants: () => void
}

function _TemplateSection(props: Props) {
  const company = props.currentCompanyStore!.company!
  const canUseGlobalCatalog = props.currentCompanyStore?.canUseGlobalCatalog
  const isMasterProduct = props.product.isMasterProduct

  const [expanded, setExpanded] = useState(false)
  const buttonTitle = `Import ${isMasterProduct ? 'variant ' : ''}from ${parseProvinceProductAgency(
    canUseGlobalCatalog ? null : company.province,
  )}`

  return (
    <>
      <div style={{ display: 'flex', flexFlow: 'row nowrap' }}>
        <div>
          <BlazeButton
            buttonProps={{
              icon: 'plus',
              style: {
                backgroundColor: 'var(--light)',
              },
              onClick: () => {
                Track.track('dashboard:products_provinceImportButtonClicked', {
                  type: isMasterProduct ? 'variants' : 'standalone',
                })
                setExpanded(!expanded)
              },
            }}
            titleProps={{ title: buttonTitle }}
          />
        </div>
        {props.warning && (
          <small className='text-muted ml-2' style={{ maxWidth: '15rem' }}>
            {props.warning}
          </small>
        )}
      </div>
      {expanded && canUseGlobalCatalog && (
        <ImportGlobalProduct
          activeKeys={props.activeKeys}
          setActiveKeys={props.setActiveKeys}
          populateGlobalProduct={props.populateGlobalProduct}
          product={props.product}
          setExpanded={setExpanded}
          autoScrollToVariants={props.autoScrollToVariants}
        />
      )}
      {expanded && !canUseGlobalCatalog && (
        <ImportProvinceProduct
          activeKeys={props.activeKeys}
          setActiveKeys={props.setActiveKeys}
          populateProduct={props.populateProduct}
          product={props.product}
          setExpanded={setExpanded}
          autoScrollToVariants={props.autoScrollToVariants}
        />
      )}
    </>
  )
}

export const TemplateSection = inject('currentCompanyStore')(observer(_TemplateSection))
